<script>
import CTA from '@phoenix/mixins/components/common/CTA';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: { PhxIcon },

  mixins: [CTA],

  computed: {
    baseClasses() {
      return ['sgphx-btn', { 'sgphx-btn--icon': this.icon !== null }];
    },
  },
};
</script>

<template>
  <div class="sgphx">
    <a :href="link" v-bind="attributes" :class="getClasses">
      <span v-if="icon" class="sgphx-btn__icon sgphx-btn__icon--start">
        <phx-icon :icon="icon" :class="`sgphx-icon sgphx-icon--${icon} sgphx-icon--sm`" />
      </span>
      <span class="sgphx-btn__text">
        <span v-html="getText" />
      </span>
    </a>
  </div>
</template>
